export const SCHOOL_DATA_CONSTANTS = {
  statusLabels: {
    resource: "Resource Okay",
    app: "App Okay",
    mdm: "TPS Okay",
    tab: "Tab",
    tabs: "Tabs",
    tv: "TV",
    tvs: "TVs",
    sdCard: "SD Card Okay",
    firmware: "Firmware Okay",
    productType: "Product Type"
  },
  btns: {
    logout: "Logout",
    search: "Search",
    create: "Create"
  },
  actions: {
    persistence: "content_persistence",
    click: "one_click",
  },
  online: "Online",
  messages: {
    notAvailable:
      "Looks like none of the users have come online in the last 30 days, <br /> Please contact customer support for more details.",
    default: "Please enter above details <br /> and get the check list.",
    wait: "Wait for 15 mins for this status to update",
    wentWrong: "Something went wrong!!",
    enrollSuccess:
      "The device has been successfully added to the enrolment pipeline and will be ready for use soon.",
    loading: "Loading...",
  },
  tvEnrollmentErrors: {
    invalid:
      "Invalid device ID. Please make sure the device ID contains only letters (a-z, A-Z) and numbers (0-9). For example, a valid device ID can be: 41f38df5026554c5",
    length:
      "Invalid device Id. A valid device Id must have 16 characters. For example, a valid device ID can be: 41f38df5026554c5",
    enrollFailed: "Something went wrong, Please try again",
  },
  networkOnly: "network-only",
  device: {
    tab: "tab",
    tv: "tv",
  },
};

export const DEVICE_INFO_OBJ = {
  id: "",
  msg: "",
  status: "",
  validationMsg: "",
  isFieldChanged: false,
  triggerFrom: "manual",
};

export const OTP_DATA_INITAL_STATE = {
  data: {
    attempts: 0,
    expiredTime: "",
    otpCode: "",
  },
  error: "",
};

export const DEVICE_TYPE = {
  camera: "camera",
  gallery: "gallery",
  manual: "manual",
};

export const GOOD_SYSTEM_BUILD_VERSION = [
  "TB-7305X_S000126_220620_ROW",
  "TB-7305X_S100100_221219_ROW",
  "TB-7306F_S000048_221208_ROW",
  "TB-7306F_S000049_230206_ROW",
  "TB-7306F_S000052_230331_ROW",
  "TB-7306F_S000054_230713_ROW",
  "TB-7306F_S000057_230920_ROW",
  "TB-7306X_S000052_221104_ROW",
  "TB-7306X_S000053_221226_ROW",
  "TB-7306X_S000054_230222_ROW",
  "TB-7306X_S000055_230412_ROW",
  "TB-7306X_S000056_230721_ROW",
  "TB-7306X_S000057_230920_ROW",
  "TB-8505F_S300637_220706_BMP",
  "TB-8505F_S301106_230914_BMP",
];

export const DRAWER_CONSTANTS = {
  oneClickMenuItem: "one-click",
  badFirmwareMenuItem: "bad-firmware",
  drawerState: "drawer-state",
  menuItemState: "menu-item-state",
  createNewOrder: "create-new-order",
  installationReport: "installation-report",
};

export const METABASE_IFRAME_HEIGHT = {
  default: 400,
  large: 1000,
};

export const NEW_SD_CARD_VERSION_AY = 8;

export const TIMELINE_CONSTANTS = {
  DEFAULT_PAGE_NO: 1,
  DEFAULT_PAGE_LIMIT: 10,
  PAGE_SIZE_CONFIG: [5, 10, 20, 50, 100]
}

export const SD_CARD_PROFILE_NAME = {
  407: "AY8_PP_to_G10_LEAD_Expert",
  406: "AY8_PP_to_G10_Altus_FBS",
  409: "AY8_PP_to_G5_LEAD_Expert",
  465: "AY8_G6_to_G10_FBS_Altus",
  466: "AY8_G6_to_G10_LEAD",
  449: "AY8_PP_to_G10_CBSE_A",
  451: "AY8_Propel",
  450: "AY8_Pinnacle",
  454: "AY8_RJSCERT",
  479: "AY8_PP_to_P_KASCERT",
  477: "AY8_PP_to_P_TLSCERT",
  478: "AY8_PP_to_P_TNSCERT",
  476: "AY8_PP_to_P_APSCERT"
}

export const PRODUCT_TYPE_CONFIG = [
  {
    productName: 'lead',
    label: 'LEAD', // default
    logo: `${process.env.REACT_APP_NUCLEUS_CDN_URL}/lead/logo_dark.svg`,
  },
  {
    productName: 'propel',
    label: 'Propel',
    logo: `${process.env.REACT_APP_NUCLEUS_CDN_URL}/propel/logo_light.svg`,
  },
  {
    productName: 'pinnacle',
    label: 'Pinnacle+',
    logo: `${process.env.REACT_APP_NUCLEUS_CDN_URL}/pinnacle/logo_dark.svg`,
  }
]